// extracted by mini-css-extract-plugin
module.exports = {"heading_text":"Heading_heading_text__21hne","heading_div":"Heading_heading_div__puyvS","projects_div_main":"Heading_projects_div_main__Nqwiu"};